import React from "react";
import RatingBar from "../misc/elements/RatingBar";

const RatingEstimation = ({ icon, rating, rateClick }) => {
  return (
    <RatingBar
      onClick={(rating) => rateClick(rating)}
      direction={"divRow"}
      imageSize={40}
      image={icon}
      rating={rating}
    />
  );
};

export default RatingEstimation;
